import { Badge, Button, Col, Modal, Row, Pagination,Spin  } from "antd";
import { useEffect, useState } from "react";
import { useDispatch,useSelector } from "react-redux";
import "./AccountsModal.css";
import history from "../../routes/history";
import { getCookie } from "../../shared/helpers";
import AdminTag from "../../assets/icons/AdminTag.svg";
import AbsTag from "../../assets/icons/AbsTag.svg";
import { getAbsAccounts } from "../../redux/actions"; 

const AccountsModal = (props) => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const pageSize = 5; 
const { ABS, absLoading, pagination } = useSelector((state) => state.profileReducer);
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
		return {
			width,
			height,
		};
  }

  const handleOk = () => {
    props.setBtnVisible(false);
  };

  const handleCancel = () => {
    props.setBtnVisible(false);
  };

  const token = getCookie("token");
  const currentUserEmail = props?.email;

  return (
    <>
   <Modal
  closable={true}
  title={<div style={{ paddingLeft: windowDimensions.width <= 765 ? "15px" : "8px" }}>Select ABS</div>}
  footer={
    pagination?.totalCount > pageSize ? (
      <div style={{ textAlign: "center", marginTop: "20px" }} className="no-accounts-modal">
        <Pagination
          current={pagination?.currentPage || currentPage}
          pageSize={pagination?.pageSize || pageSize}
          total={pagination?.totalCount || 0}
          onChange={(page) => {
            setCurrentPage(page);
            dispatch(getAbsAccounts(page, pageSize));
          }}
        />
      </div>
    ) : null
  }
  cancelButtonProps={{ style: { display: "none" } }}
  okButtonProps={{ style: { display: "none" } }}
  className={`accounts-modal ${
    windowDimensions.width <= 765 ? "mobile-fullscreen" : "web-modal"
  }`}
  open={props.btnVisible}
  onOk={handleOk}
  onCancel={handleCancel}
>
  {absLoading ? (
    <div
      style={{
        height: "300px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <>
      {props.ABS?.sort((x, y) => {
          const isCurrentUserX = currentUserEmail === x.AMEmail || currentUserEmail === x.ABSEmail;
          const isCurrentUserY = currentUserEmail === y.AMEmail || currentUserEmail === y.ABSEmail;

        if (isCurrentUserX && !isCurrentUserY) return -1;
        if (!isCurrentUserX && isCurrentUserY) return 1;

        let a = x.ABS?.toUpperCase(),
          b = y.ABS?.toUpperCase();
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }).map((res, index) => {
        let isAdmin =
          (currentUserEmail === res.AMEmail && currentUserEmail === res.ABSEmail) ||
          (res.AMEmail === res.ABSEmail);

        return (
          <div
            key={index}
            className="Employer_name"
            style={{
                color: res?.ABSEmail == res?.HRMEmail ? "#118936" : props.pereferedName && "#118936",
            }}
            onClick={() => {
              localStorage.setItem("userProfile", JSON.stringify({ profile: null }));
              localStorage.setItem("Email", res?.ABSEmail);
                window.location.replace(
                  `/employer/auth?userId=${res?._id}&token=${token}`
                );
            }}
          >
              <Row style={{ paddingTop: "15px", display: "flex", justifyContent: "space-between" }}>
              <Col md={20} p={2}>
                <Row>
                  {res?.ABS} &nbsp; <img src={isAdmin ? AdminTag : AbsTag} alt="Tag" />
                </Row>
										<Row>
											{res?.ABSEmail}
										</Row>
              </Col>
              {res?.EmployerUnread > 0 ? (
										<Col md={4} style={{ textAlign: "center", paddingLeft: "30px", paddingRight: windowDimensions.width <= 768 ? "26px" : "" }}>
                  <Badge dot={true} color={"green"} />
                </Col>
              ) : null}
            </Row>
          </div>
        );
      })}
    </>
  )}
</Modal>
    </>
  );
};

export default AccountsModal;